/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { Box, Heading } from "@towersystems/towersystems-design-system";
import { map, noop, filter } from "lodash";

/**
 * Internal dependencies
 */
import FormRadiosBar from "components/forms/form-radios-bar";
import GraphCubeMetaData from "data/graph-cube-meta-data";
import { getCubes } from "state/graph-cube/selectors";

// these are going to be hard coded.. because there is no dynamic way
// to know which cubes can be selected...
const validCubes = [
  "Sale",
  "SaleItem",
  "Product",
  "InventoryItem",
  "Location",
  "Category",
  "Department",
  "Supplier",
  "CustomerDebtor",
  "CustomerCredit",
  "EosTotal",
  "ProformaBalance",
  "WeblinkGroup",
  "LaybyTotal",
  "InventoryAnalysis",
  "ABCInventoryAnalysis",
];

const SelectSingleData = ({ cubes, value, onChange = noop }) => {
  const [dataSet, setDataSet] = useState(value || "");

  const handleChange = (e) => {
    let value = e.target.value;
    setDataSet(value);
    onChange(value);
  };

  let items = map(
    filter(cubes, ({ name }) => validCubes.includes(name)),
    ({ name, title }) => ({
      key: name,
      value: name,
      label: title,
    })
  );

  return (
    <Box>
      <Box marginBottom="large">
        <Heading level="4">Choose one series data set</Heading>
      </Box>
      <FormRadiosBar checked={dataSet} items={items} onChange={handleChange} />
      <GraphCubeMetaData />
    </Box>
  );
};

export default connect((state) => ({
  cubes: getCubes(state),
}))(SelectSingleData);
